import React from "react";
import { useTranslation } from "react-i18next";

const GeneralFormError = ({ errors }) => {
  const { t } = useTranslation("common");

  function formatError(error) {
    if (Array.isArray(error)) {
      return error[0];
    }

    if (typeof error === "string") {
      return error;
    }

    return null;
  }

  function showFormattedError() {
    if (!errors || Object.keys(errors).length === 0) {
      return null;
    }

    const baseError = formatError(errors.base);

    if (baseError) {
      return baseError;
    }

    for (const [key, value] of Object.entries(errors)) {
      if (key === "base") continue;

      const error = formatError(value);

      if (error) {
        return error;
      }
    }

    return t("errors.general.unknown");
  }

  const formattedError = showFormattedError();

  return (
    <>
      {formattedError && (
        <div className={"alert alert-danger"}>{formattedError}</div>
      )}
    </>
  );
};

export default GeneralFormError;
